import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { Currency, CurrencyProps } from 'models/reusable-parts/currency';

export interface DetailsProps {
  business: CurrencyProps;
  personal: CurrencyProps;
  minimumSpend: CurrencyProps;
}

export const Details = types.model({
  business: Currency,
  personal: Currency,
  minimumSpend: Currency,
});

export type DetailsSnapshot = SnapshotIn<typeof Details>;
export type DetailsInstance = Instance<typeof Details>;

export interface DetailsGroupProps {
  monthly?: DetailsProps;
  yearly?: DetailsProps;
}

export const DetailsGroup = types.model({
  monthly: types.maybe(Details),
  yearly: types.maybe(Details),
});

export type DetailsGroupSnapshot = SnapshotIn<typeof DetailsGroup>;
export type DetailsGroupInstance = Instance<typeof DetailsGroup>;
